import { Container, Divider, Header, SummaryGroup, useAlignments, useSizes } from 'metrix-common3';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Vehicle from './Vehicle';

const ProfileVehicles = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const [mode, setMode] = useState('summary');
    const [current, setCurrent] = useState(null);

    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        props.doGetPolicy();
    }, []);

    const getVehicles = () => {
        const vehicles = [];

        if (props.policy?.vehicles && props.policy.vehicles.length > 0) {
            props.policy.vehicles.forEach((vehicle) => {
                const option = { code: 'vehicle', value: vehicle.guid };

                let vehicleName = (
                    <FormattedMessage
                        key={vehicle.guid}
                        id='Profile_Vehicles.vehicle'
                        values={{ number: vehicle.number }}
                    />
                );

                if (vehicle.year && vehicle.make) {
                    vehicleName = `${vehicle.year} ${vehicle.make}`;
                }

                option.elements = [];

                option.elements.push({ code: 'Label', value: vehicleName });
                //option.elements.push({ code: 'Status', value: 'Complete' });

                vehicles.push(option);
            });
        }

        return vehicles;
    };

    const getDrivers = () => {
        const drivers = [];

        if (props.policy?.drivers && props.policy.drivers.length > 0) {
            props.policy.drivers.forEach((driver) => {
                let driverName = (
                    <FormattedMessage
                        key={driver.guid}
                        id='Profile_Vehicles.driver'
                        values={{ number: driver.number }}
                    />
                );

                if (driver.party.name) {
                    driverName = `${driver.party.name.firstName} ${driver.party.name.lastName}`;
                }

                const option = { code: driver.guid, value: driverName };

                drivers.push(option);
            });
        }

        return drivers;
    };

    const vehicles = getVehicles();
    return (
        <Container>
            {mode === 'summary' && (
                <React.Fragment>
                    <Divider top={sizes.xl} />
                    <Header
                        size={sizes.lg}
                        textAlign={alignments.left}
                        text={<FormattedMessage id='Profile_Vehicles.vehicles' />}
                    />
                    <Container top={sizes.xl} bottom={sizes.xl}>
                        <SummaryGroup
                            allowAdd={props.allowEdit}
                            addEvent={() => {
                                props.doReduceParameters([]);
                                props.doExecutePolicyAction({ code: 'CREATEVEHICLE' });
                            }}
                            allowEdit
                            editEvent={(vehicle) => {
                                setCurrent(vehicle);
                                setMode('vehicle');
                                props.doReduceParameters([{ code: 'Vehicle', value: vehicle }]);
                            }}
                            allowDelete={props.allowEdit}
                            deleteEvent={(vehicle) => {
                                props.doReduceParameters([{ code: 'Vehicle', value: vehicle }]);
                                props.doExecutePolicyAction({ code: 'DELETEVEHICLE' });
                            }}
                            entities={vehicles}
                            icon='vehicle'
                        />
                    </Container>
                </React.Fragment>
            )}
            {mode === 'vehicle' && (
                <Vehicle
                    vehicle={props.policy.vehicles.find((x) => x.guid === current)}
                    vehicleUses={props.policy.vehicleUses}
                    drivers={getDrivers()}
                    dotProp={`vehicles.${props.policy.vehicles.findIndex((x) => x.guid === current)}.`}
                    backEvent={() => {
                        setMode('summary');
                        setCurrent(null);
                    }}
                    doUpsertPolicy={props.doUpsertPolicy}
                    doGetPolicy={props.doGetPolicy}
                    doReduceParameter={props.doReduceParameter}
                    doReducePolicyElement={props.doReducePolicyElement}
                    doExecutePolicyAction={props.doExecutePolicyAction}
                    reference={props.reference}
                    context={props.context}
                    allowEdit={props.allowEdit}
                />
            )}
        </Container>
    );
};

export default ProfileVehicles;
